"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _textBlockArticle = _interopRequireDefault(require("../styles/text-block-article.css"));
var dataUtils = new _mmcDataUtilities["default"]();
var renderEmptyString = dataUtils.renderEmptyString;
var shouldFormatDate = function shouldFormatDate(date, region) {
  var formatedDate = new Date(parseInt(date));
  var options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  var formatedRegion = region.toLowerCase();
  var fullDate = formatedDate.toLocaleDateString(formatedRegion, options);
  if (region === ' ' || fullDate === 'Invalid Date') {
    return ' ';
  }
  return fullDate;
};
var DateLabel = function DateLabel(_ref) {
  var date = _ref.date,
    time = _ref.time,
    config = _ref.config,
    theme = _ref.theme,
    enableReadTime = _ref.enableReadTime,
    enableArticleDate = _ref.enableArticleDate;
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: _textBlockArticle["default"].date + " " + theme.labelMedium
  }, enableArticleDate && shouldFormatDate(date, renderEmptyString(config.localeCode)), enableReadTime && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'inline-block'
    }
  }, enableArticleDate && enableReadTime && /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + _textBlockArticle["default"].circularDot
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: _textBlockArticle["default"].date + " " + theme.labelMedium
  }, time)));
};
DateLabel.displayName = 'DateLabel';
DateLabel.defaultProps = {
  date: '',
  time: '',
  config: {},
  theme: {}
};
var _default = DateLabel;
exports["default"] = _default;